exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.skeleton[data-v-e681f790] {\n  border-color: rgb(217, 217, 217);\n  border-radius: 4px;\n  height: 32px;\n  width: 100%;\n}\n.validation-error[data-v-e681f790] {\n  font-style: italic;\n  color: red;\n  text-align: right;\n}\n", ""]);

// exports
